<div class="mt-5 d-flex justify-content-between">
    <ngb-pagination *ngIf="isPageable" [collectionSize]="pageOptions?.length" [pageSize]="pageOptions?.defaultPageSize"
        (pageChange)="pageEvent.emit($event)" [rotate]="true" [maxSize]="4" [ellipses]="true" [boundaryLinks]="true" [page]="pageOptions?.page">
    </ngb-pagination>
</div>